import http from "./http-common";

class DoctorService {
  queryString(payload) {
    const QueryString = Object.keys(payload)
      .map((key) => key && payload[key] && key + "=" + payload[key])
      .join("&");
    return QueryString;
  }

  editDoctorDetails(payload, id) {
    return http.put(`/user/${id}`, payload);
  }

  getHospitalAccountData(id) {
    return http.get(`/accountMaster/list/filter?account_Id=${id}`);
  }
  getClinicList(payload) {
    const queryString = new URLSearchParams(payload).toString();
    return http.get(`/Clinic_Master/list/filter?${queryString}`);
  }
  AccountList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/accountMaster/list/filter?${queryString}`);
  }
  chronicList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/chronicConditions/list/filter
?${queryString}`);
  }
  referedList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/Referral/list/filter
?${queryString}`);
  }
  getDoctorData(id) {
    return http.get(`/user/list/filter?userId=${id}`);
  }
  getDoctors(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/user/list/filter?${queryString}`);
  }
  referToSave(payload) {
    return http.post(`/Referral/`, payload);
  }
  getDoctorSpeciality(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/Speciality/list?${queryString}`);
  }
}
export default new DoctorService();
